import React, { useState, useEffect } from 'react';
import { Link } from 'react-router';
import styles from './CategoriesPageRedesign.module.scss';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop/ScrollToTop';
import { allCategories } from '../../../data/categories';

const CategoriesPageRedesign: React.FC = () => {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  return (
    <div className={styles.categoriesPage}>
      <Header />

      <div className={styles.contentWrapper}>
        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>All Categories</h1>
          <p className={styles.pageSubtitle}>
            Browse products by category
          </p>
        </div>

        <div className={styles.categoriesGrid}>
          {allCategories.map((category) => (
            <Link
              key={category.id}
              to={`/search?category=${encodeURIComponent(category.id)}`}
              className={styles.categoryCard}
              data-category={category.id}
            >
              <div className={styles.categoryIconWrap}>
                <img
                  src={category.icon}
                  alt={category.name}
                  className={styles.categoryIcon}
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.src = `${process.env.PUBLIC_URL}/images/store-desktop-thumbnail.png`;
                  }}
                />
                {category.tag && (
                  <span className={`${styles.categoryTag} ${styles[`tag-${category.tag.type || 'default'}`]}`}>
                    {category.tag.text}
                  </span>
                )}
              </div>
              <span className={styles.categoryName}>{category.displayName || category.name}</span>
            </Link>
          ))}
        </div>
      </div>

      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default CategoriesPageRedesign;
